import { ConfigProvider, theme } from 'antd';

export const AntdConfigProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        components: {
          Select: {
            borderRadius: 12,
            controlHeight: 44,
            controlPaddingHorizontal: 12,
            optionSelectedBg: 'var(--color-Base-active-secondary)',
            optionSelectedColor: 'var(--color-Text-link-color)',
            colorTextDisabled: 'var(--color-Text-primary-hint)',
            colorBgContainer: 'var(--color-Base-accent-secondary-disabled)',
            colorBorder: 'transparent',
            colorPrimaryHover: 'transparent',
            activeBorderColor: 'transparent',
            controlOutline: 'none',
            colorBgElevated: 'var(--color-Base-secondary-background)',
          },
          Table: {
            headerBg: 'transparent',
            rowHoverBg: 'transparent',
            headerColor: 'rgba(255, 255, 255, 0.85)',
          },
          Slider: {
            dotSize: 0,
            handleSize: 9,
            handleSizeHover: 9,
            handleColor: '#935FFA',
            handleActiveColor: '#935FFA',
            handleActiveOutlineColor: 'rgba(251, 163, 250, 0.06)',
            dotBorderColor: '#935FFA',
            dotActiveBorderColor: '#935FFA',
            margin: 0,
            trackBg: 'var(--color-Brand-premium)',
            railBg: 'rgba(255, 255, 255, 0.1)',
            trackHoverBg: 'var(--color-Brand-premium)',
          },
          DatePicker: {
            cellActiveWithRangeBg: 'red',
          },
          Modal: {
            colorBgContainer: 'var(--color-Base-secondary-background)',
            borderRadius: 24,
            borderRadiusLG: 24,
            borderRadiusSM: 24,
            borderRadiusXS: 24,
            borderRadiusOuter: 24,
          },
          Switch: {
            handleBg: 'rgba(255, 255, 255, 1)',
            handleSize: 27,
            trackHeight: 31,
            trackPadding: 2,
            trackMinWidth: 51,
          },
          Tree: {
            nodeHoverBg: 'transparent',
            nodeSelectedBg: 'transparent',
            nodeSelectedColor: 'rgba(255, 255, 255, 0.85)',
            nodeHoverColor: 'rgba(255, 255, 255, 0.85)',
          },
          Tooltip: {
            colorBgSpotlight: 'var(--color-Base-Button-Secondary)',
            colorTextLightSolid: 'var(--color-Base-background)',
          },
        },
        token: {
          colorBgContainer: 'transparent',
          colorTextPlaceholder: 'rgba(255, 255, 255, 0.30)',
          colorText: 'rgba(255, 255, 255, 0.85)',
          colorTextDisabled: 'rgba(255, 255, 255, 0.3)',
        },
      }}>
      {children}
    </ConfigProvider>
  );
};
export default AntdConfigProvider;
